import { useCallback, useEffect, useState } from 'react'
import { shallowEqual, useSelector } from 'react-redux'

import MediaService from '../../services/MediaService'
import UnitNavigation from '../../components/Navigation/UnitNavigation'
import Surprise from '../../components/World/Surprise/Surprise'
import { GetUserVideo, getVideo } from '../../s3Func/s3Download'

const Module3Nav = () => {
	const { module3 } = useSelector((state) => state.module3, shallowEqual)
	const { login } = useSelector((state) => state.loginReducer, shallowEqual)

	/*****************************
	 * BG Image Logic
	 ******************************/

	const [bgImage, setBgImage] = useState('')
	const [displaySurprise, setDisplaySurprise] = useState(false)
	const [surpriseConfig, setSurpriseConfig] = useState(null)

	const checkScreenSize = useCallback(
		(el) => {
			const desktopImage = '/Module3Images/U1M3_DayScene_Landscape.png'
			const mobileImage = '/Module3Images/Module3NavImages/M3_Path_Mobile.png'

			el.screen && el.screen.width < 1025
				? setBgImage(mobileImage)
				: setBgImage(desktopImage)
		},
		[setBgImage]
	)

	const resizeListener = useCallback(() => {
		window.addEventListener(
			'resize',
			(event) => checkScreenSize(),
			true
		)
	}, [checkScreenSize])

	useEffect(() => {
		checkScreenSize(window)
		resizeListener()
	})

	const backgroundPath = bgImage && MediaService.getImage(bgImage, login)
	const worldBG = MediaService.getImage(
		'/Module3Images/U1M3_DayScene_Landscape.png',
		login
	)

	/*****************
	 *  Day Logic
	 * ***************/

	const getDayConfig = useCallback((dayNumber) => {
		let filledImageUrl = `/Module3Images/Module3NavImages/CactusDay${dayNumber}.png`
		let outlinedImageUrl = `/Module3Images/Module3NavImages/OutlineDay${dayNumber}.png`

		// Use the trophy image from module1
		if (dayNumber === 9) {
			outlinedImageUrl = '/Module1Images/Module1NavImages/Outline_Day9.png'
			filledImageUrl = '/Module1Images/Module1NavImages/Color_Day9.png'
		}

		return {
			dayNumber,
			destiny: '/facial-expression',
			filledImageUrl,
			outlinedImageUrl,
		}
	}, [])

	const daysArray = [...Array(9).keys()]
	const DAYS_CONFIG = daysArray.map((index) => getDayConfig(index + 1))

	const SURPRISE_VIDEO = {
		video: 'eda85b30f583de7fa6792097d432/480.m3u8',
		song: 'appfiles/expressions/school_expressions_instrumental.m4a',
		slides: [
			`influencers/${login.influencerid}/ask_affirmation.mp4`,
			`userfiles/${module3.StudentID}/expressions_celebration_surprise_6.mp4`,
			`userfiles/${module3.StudentID}/expressions_smile.jpg`,
			`influencers/${login.influencerid}/expressions_video_message.mp4`,
			`userfiles/${module3.StudentID}/expressions_celebration_surprise_8.mp4`,
			`userfiles/${module3.StudentID}/expressions_silly_photo_3.jpg`,
			`userfiles/${module3.StudentID}/expressions_celebration_surprise_9.mp4`,
		],
	}

	const handleSurpriseClick = async () => {
		let { slides, song, video } = SURPRISE_VIDEO

		slides = await Promise.all(
			slides.map(async (url) => await GetUserVideo(url, login))
		)
		song = await getVideo(song, login)

		setSurpriseConfig({ video, slides, song })
		setDisplaySurprise(true)
	}

	/*****************************
	 *  Component configuration
	 * ***************************/

	return (
		<>
			{displaySurprise && (
				<Surprise
					background={worldBG}
					setDisplaySurprise={setDisplaySurprise}
					video={surpriseConfig.video}
					song={surpriseConfig.song}
					slides={surpriseConfig.slides}
					onSurpriseEnded={() => setDisplaySurprise(false)}
				/>
			)}

			<UnitNavigation
				moduleName="MODULE3"
				module={module3}
				days={DAYS_CONFIG}
				totalDays={9}
				unitDestiny="/unit1"
				nextDestiny="/unit1"
				backgroundPath={backgroundPath}
				onSurpriseClick={handleSurpriseClick}
				unit={1}
				animal={MediaService.getImage('/Images/Button_Lizardhead.png', login)}
			/>
		</>
	)
}
export default Module3Nav
